(function () {
  // Transición de página con franjas + logo (ver snippets/page-transition-overlay.liquid).
  // Único mecanismo de transición del sitio: se aplica igual a navegación
  // genérica y a clics de producto, para que la experiencia sea consistente
  // en todo el sitio.
  //
  // Dos cosas se adaptan a la conexión real del visitante, medidas de nuevo
  // en cada navegación (no un valor fijo cargado una vez):
  // 1. El "hold" (cuánto se sostiene el logo) — ya era real: dura lo que
  //    tarda la navegación de verdad, con un piso mínimo para que no parpadee.
  // 2. La velocidad de la propia animación de franjas — en fibra/wifi rápido
  //    se sienten casi instantáneas; en 3G/2G se estiran un poco para que no
  //    se vean bruscas. Ver getSpeedFactor().
  var STRIPES = 9;

  // Base = velocidad de referencia (4G / LTE regular), ya recortada un 10%
  // respecto al diseño original de Claude Design.
  var BASE = {
    stripeDur: 468,
    stagger: 50,
    logoIn: 288,
    logoOut: 200,
    minHold: 450,
  };

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }

  // < 1 = más rápido que la base (fibra/wifi bueno), > 1 = más lento (3G/2G).
  function getSpeedFactor() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return 1;
    if (c.saveData) return 1.2;

    var downlink = typeof c.downlink === 'number' ? c.downlink : null;
    if (downlink != null) {
      if (downlink >= 10) return 0.6; // fibra / wifi rápido
      if (downlink >= 4) return 0.8; // 4G bueno
      if (downlink >= 1.5) return 1; // 4G regular / LTE
      return 1.2; // 3G o peor
    }

    var byType = { 'slow-2g': 1.25, '2g': 1.2, '3g': 1, '4g': 0.8 };
    return byType[c.effectiveType] || 1;
  }

  function cfg() {
    var f = getSpeedFactor();
    var stripeDur = Math.round(BASE.stripeDur * f);
    var stagger = Math.round(BASE.stagger * f);
    var logoIn = Math.round(BASE.logoIn * f);
    var logoOut = Math.round(BASE.logoOut * f);
    var minHold = Math.round(BASE.minHold * f);
    var cover = (STRIPES - 1) * stagger + stripeDur;
    return {
      stripeDur: stripeDur,
      stagger: stagger,
      logoIn: logoIn,
      logoOut: logoOut,
      minHold: minHold,
      cover: cover,
      exitTotal: logoOut + (STRIPES - 1) * stagger + stripeDur,
    };
  }

  function applyCssVars(overlay, c) {
    overlay.style.setProperty('--pt-stripe-dur', c.stripeDur + 'ms');
    overlay.style.setProperty('--pt-stagger', c.stagger + 'ms');
    overlay.style.setProperty('--pt-logo-in-dur', c.logoIn + 'ms');
    overlay.style.setProperty('--pt-logo-out-dur', c.logoOut + 'ms');
    overlay.style.setProperty('--pt-cover-ms', c.cover + 'ms');
  }

  var overlay = document.getElementById('page-transition-overlay');

  function resetOverlay(options) {
    if (!overlay) return;
    overlay.classList.add('pt-reset');
    overlay.classList.remove('pt-in', 'pt-out', 'pt-active', 'pt-hold');
    document.documentElement.removeAttribute('data-pt-cover');
    if (!options || options.clearStorage !== false) {
      try {
        sessionStorage.removeItem('pt-active');
      } catch (e) {}
    }
    requestAnimationFrame(function () {
      overlay.classList.remove('pt-reset');
    });
  }

  // Volver del navegador restaura la página anterior desde bfcache con el
  // overlay todavía cubriendo (la animación ya terminó, queda congelada).
  // En pagehide solo se limpia el DOM para el snapshot cacheado; no se borra
  // pt-active porque la página siguiente lo necesita para sostener la cubierta.
  window.addEventListener('pagehide', function () {
    resetOverlay({ clearStorage: false });
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resetOverlay();
  });
  window.addEventListener('popstate', resetOverlay);

  if (!overlay || prefersReducedMotion() || isLowPowerDevice()) {
    resetOverlay();
    return;
  }

  // Llegamos aquí cubiertos por una navegación previa: sostenemos el logo
  // hasta que la página termine de cargar (o el mínimo, lo que sea mayor).
  if (document.documentElement.hasAttribute('data-pt-cover')) {
    var c = cfg();
    applyCssVars(overlay, c);
    overlay.classList.add('pt-active', 'pt-hold');
    var holdStart = performance.now();
    var revealed = false;

    var reveal = function () {
      if (revealed) return;
      revealed = true;
      var wait = Math.max(0, c.minHold - (performance.now() - holdStart));
      setTimeout(function () {
        document.documentElement.removeAttribute('data-pt-cover');
        overlay.classList.remove('pt-hold');
        overlay.classList.add('pt-out');
        setTimeout(function () {
          overlay.classList.remove('pt-in', 'pt-out', 'pt-active');
        }, c.exitTotal + 40);
      }, wait);
    };

    if (document.readyState === 'complete') {
      reveal();
    } else {
      window.addEventListener('load', reveal);
    }
  }

  // Interceptar navegación interna para animar la cubierta antes de salir.
  // Cubre TODO enlace interno, incluidas tarjetas de producto — un solo
  // sistema de transición para todo el sitio.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || link.target || link.hasAttribute('download') || link.hasAttribute('data-no-transition')) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('#') === 0) return;

    var url;
    try {
      url = new URL(link.href, location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return; // misma página

    event.preventDefault();
    var c = cfg();
    applyCssVars(overlay, c);
    overlay.classList.add('pt-active', 'pt-in');
    try {
      sessionStorage.setItem('pt-active', '1');
    } catch (e) {}

    setTimeout(function () {
      window.location.href = link.href;
    }, c.cover + c.logoIn);
  });
})();
